//import './App.css';
import ElevateAppBar from './lib/containers/nav';
import Banner from './lib/containers/banner';
import About from './lib/containers/about';
import Organizations from './lib/containers/organizations';
import Works from './lib/containers/work';
import Skills from './lib/containers/skills';
import Footer from './lib/containers/footer';
import useWindowSize, { ScreenSize } from './lib/utils/window-size';
import BottomNav from './lib/containers/bottom-navigation';
import { AnimatedBoxLoader, AnimatedCircleLoader } from './lib/components/loading/animated-loaders';




function DesktopApp(){
  return (
    <>
      <ElevateAppBar>
        <>
          <Banner />
          <About />
          <Organizations />
          <Works />
          <Skills />
        </>
      </ElevateAppBar>
      <Footer />
    </>
  );
}

function MobileApp(){
  return (
    <>
      <BottomNav />
    </>
  )
}


function App() {

  const windowSize = useWindowSize();
  
  if(windowSize.width === 0){
    //* Show Application is loading 
    return <AnimatedCircleLoader />
  }else if(windowSize.width > ScreenSize.sm){
    return <DesktopApp />
    //* Show Application is Desktop
  }else{
    return <MobileApp /> 
    //* Show Application is Mobile
  }
  
}

export default App;
